import { render } from "./ContactView.vue?vue&type=template&id=72752b90&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=72752b90&scoped=true&lang=css"

import exportComponent from "C:\\source\\LETC\\CorpWebsite\\LETC_vr_Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72752b90"]])

export default __exports__